import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tile-gift-card',
  templateUrl: './tile-gift-card.component.html',
  styleUrls: ['./tile-gift-card.component.less']
})
export class TileGiftCardComponent implements OnInit {

  @Input() img: string;
  @Input() brandLogo: string;

  constructor() { }

  ngOnInit(): void {
  }
}
